module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class=\'session-timeout-overlay-content-wrapper\'>\n  <div class="session-timeout-overlay-f-logo-region"></div>\n  <div class="session-timeout-overlay-text-click-continue-icon"></div>\n  <div class="session-timeout-overlay-text-you-there">Are you still there?</div>\n  <div class="session-timeout-overlay-text-reset-in"> Your session will reset in</div>\n  <div class=\'session-timeout-overlay-countdown-region\'><div>\n<div>\n';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/elo-app/session-timeout-overlay/session-timeout-overlay.html
 ** module id = 1119
 ** module chunks = 1 89
 **/